import { useEffect } from 'react';
import { useLocation } from 'react-router-dom';

// Basic認証が必要なページのリスト
const AUTH_REQUIRED_PATHS = [
  '/',
  '/contact',
];

// 公開パス（Basic認証不要）
const PUBLIC_PATHS = [
  '/privacy-policy',
  '/terms-of-service',
  '/commercial-transactions',
  '/account-deletion',
  '/login',
];

// パスが認証が必要かどうかを判定
function isAuthRequired(path: string): boolean {
  // 完全一致
  if (AUTH_REQUIRED_PATHS.includes(path)) {
    return true;
  }
  // /schools/:schoolId パターン
  if (path.startsWith('/schools/')) {
    return true;
  }
  return false;
}

/**
 * 認証が必要なページにクライアントサイドルーティングでアクセスした場合、
 * 公開パスから遷移した場合はページをリロードしてサーバー側のBasic認証チェックを実行する
 */
export function useAuthGuard() {
  const location = useLocation();

  useEffect(() => {
    // 認証が必要なページにアクセスした場合
    if (isAuthRequired(location.pathname)) {
      // セッションストレージにクライアントサイドルーティングのフラグを設定
      const isClientSideNavigation = sessionStorage.getItem('__lp_client_nav') === 'true';
      
      // 公開パスから遷移した場合、または初回アクセスでクライアントサイドルーティングの場合
      const referrer = document.referrer;
      const isFromPublicPath = PUBLIC_PATHS.some(path => referrer.includes(path));
      
      if (isFromPublicPath || (isClientSideNavigation && !referrer)) {
        // ページをリロードしてサーバー側のBasic認証チェックを実行
        sessionStorage.removeItem('__lp_client_nav');
        window.location.href = location.pathname + location.search;
        return;
      }
      
      // クライアントサイドルーティングのフラグをクリア
      sessionStorage.removeItem('__lp_client_nav');
    } else {
      // 公開パスにアクセスした場合は、クライアントサイドルーティングのフラグを設定
      sessionStorage.setItem('__lp_client_nav', 'true');
    }
  }, [location.pathname, location.search]);
}

